class Mouse {
  constructor() {
    this.position = { x: 0, y: 0 };

    this.pressedButtons = new Set();
    this.justPressed = new Set();

    this.swipeStart = { x: 0, y: 0 };
    this.justSwipes = new Set();
    this.MIN_SWIPE_DISTANCE = 50;

    this.handleMouseMove = this.handleMouseMove.bind(this);
    this.handleMouseDown = this.handleMouseDown.bind(this);
    this.handleMouseUp = this.handleMouseUp.bind(this);
    this.handleTouchStart = this.handleTouchStart.bind(this);
    this.handleTouchEnd = this.handleTouchEnd.bind(this);

    window.addEventListener("mousemove", this.handleMouseMove);
    window.addEventListener("mousedown", this.handleMouseDown);
    window.addEventListener("mouseup", this.handleMouseUp);
    window.addEventListener("touchstart", this.handleTouchStart);
    window.addEventListener("touchend", this.handleTouchEnd);
  }

  handleMouseMove(event) {
    this.position.x = event.clientX;
    this.position.y = event.clientY;
  }

  handleMouseDown(event) {
    const button = event.button;

    if (!this.pressedButtons.has(button)) {
      this.justPressed.add(button);
    }

    this.pressedButtons.add(button);
  }

  handleTouchStart(event) {
    this.swipeStart.x = event.changedTouches[0].screenX;
    this.swipeStart.y = event.changedTouches[0].screenY;
  }

  handleTouchEnd(event) {
    const dx = event.changedTouches[0].screenX - this.swipeStart.x;
    const dy = event.changedTouches[0].screenY - this.swipeStart.y;

    const absX = Math.abs(dx);
    const absY = Math.abs(dy);

    if (Math.max(absX, absY) >= this.MIN_SWIPE_DISTANCE) {
      if (absX > absY) {
        if (dx > 0) {
          this.justSwipes.add("right");
        } else {
          this.justSwipes.add("left");
        }
      } else {
        if (dy > 0) {
          this.justSwipes.add("down");
        } else {
          this.justSwipes.add("up");
        }
      }
    }
  }

  handleMouseUp(event) {
    const button = event.button;

    this.pressedButtons.delete(button);
  }

  isDown(button) {
    return this.pressedButtons.has(button);
  }

  isJustPressed(button) {
    return this.justPressed.has(button);
  }

  justSwiped(direction) {
    return this.justSwipes.has(direction);
  }

  inElement(element) {
    if (!element) return false;

    return element.contains(
      document.elementFromPoint(this.position.x, this.position.y)
    );
  }

  endFrame() {
    this.justPressed.clear();
    this.justSwipes.clear();
  }

  destroy() {
    window.removeEventListener("mousemove", this.handleMouseMove);
    window.removeEventListener("mousedown", this.handleMouseDown);
    window.removeEventListener("mouseup", this.handleMouseUp);
  }
}

export { Mouse };
